
import React from 'react';
import { format, isSameDay } from 'date-fns';
import { hu } from 'date-fns/locale';
import { Event } from '@/lib/types';
import { getEventsForDay } from '@/utils/eventUtils';

interface CalendarDaysHeaderProps {
  days: Date[];
  cellWidth: number;
  daysToShow: number;
  filteredEvents: Event[];
}

const CalendarDaysHeader = ({ days, cellWidth, daysToShow, filteredEvents }: CalendarDaysHeaderProps) => {
  const today = new Date();
  
  // Always display all days in the header, regardless of whether there are events
  return (
    <div className="flex bg-medihub-headerBg rounded-t-lg shadow-sm font-sans">
      {days.map((day, index) => {
        const eventsForDay = getEventsForDay(filteredEvents, day);
        const hasEventsForDay = eventsForDay.length > 0;
        const isToday = isSameDay(day, today);
        
        return (
          <div 
            key={`header-${index}`} 
            className={`py-3 px-2 font-medium text-center border-b border-r last:border-r-0 border-medihub-midPurple/30 
              ${isToday ? 'bg-medihub-softGray/70' : ''}
              ${!hasEventsForDay ? 'text-medihub-secondary/80' : ''}`}
            style={{
              width: `${cellWidth}px`,
              minWidth: `${cellWidth}px`,
              maxWidth: `${cellWidth}px`
            }}
          >
            <div className={`text-medihub-secondary text-xs font-medium ${isToday ? 'font-bold' : ''}`}>
              {format(day, 'EEEE', { locale: hu })}
            </div>
            <div className={`${isToday ? 'text-medihub-primary font-bold text-lg' : hasEventsForDay ? 'text-gray-900' : 'text-gray-500'} font-semibold text-lg`}>
              {format(day, 'd', { locale: hu })}
            </div>
            <div className={`text-xs ${isToday ? 'text-medihub-primary font-bold' : 'text-medihub-secondary/80'}`}>
              {format(day, 'MMM', { locale: hu })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CalendarDaysHeader;
